import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AuthProvider from 'router/AuthProvider';
import AuthContext from 'router/AuthContext';

import Default from '../layout/Default';
import LogIn from '../views/LogIn';
import Join from '../views/Join';
import InfoMng from '../views/users/InfoMng';
import SubUserMng from '../views/users/SubUserMng';
import Company from '../views/users/Company';
import LogMng from '../views/LogMng';
import LogStat from '../views/LogStat';
import UserMng from '../views/admin/UserMng';
import PgmMng from '../views/admin/PgmMng';
import ApiKeyMng from '../views/admin/ApiKeyMng';
import ExtensionMng from '../views/admin/ExtensionMng';
import AdminCompanyMng from '../views/admin/CompanyMng';
import AdminCouponMng from '../views/admin/CouponMng';
import PgmList from '../views/PgmList';
import ActiveCodeMng from '../views/ActiveCodeMng';
import AdminActiveCodeMng from '../views/admin/AdminActiveCodeMng';
import CouponMng from '../views/CouponMng';
import CouponMng2 from '../views/CouponMng2';
import MailMng from '../views/admin/MailMng';
import MailForward from '../views/admin/MailForward';
import MailDetail from '../views/admin/MailDetail';
import DisableMng from '../views/admin/DisableMng';
import FormMng from '../views/admin/FormMng';
import List from '../views/board/List';
import Register from '../views/board/Register';
import Detail from '../views/board/Detail';
import GeoCoding from '../views/GeoCoding';

import { authUtils } from 'utils/authUtils.js';
import DidasRoute from '../components/Router/DidasRoute';
import UserRoute from '../components/Router/UserRoute';
import ManagerRoute from '../components/Router/ManagerRoute';
import AdminRoute from '../components/Router/AdminRoute';

import { DACDashBoard, DACDashBoardAnlsSales, DACDashBoardAnlsSw, DACDashBoardAnlsUser, DACDashBoardOrdHist } from '../views/admin/dashboard';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LogIn />} />
        <Route path="/join" element={<Join />} />
        <Route
          path="/didas-main/:key"
          element={
            <DidasRoute>
              <Default />
            </DidasRoute>
          }
        >
          <Route index element={<PgmList />} />
        </Route>
        <Route
          path="/didas-geo/:key"
          element={
            <DidasRoute>
              <GeoCoding />
            </DidasRoute>
          }
        />
        <Route
          path="/didas-anls/:key"
          element={
            <DidasRoute>
              <DACDashBoardAnlsSales />
            </DidasRoute>
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Default />
            </RequireAuth>
          }
        >
          <Route
            index
            element={
              <UserRoute>
                <PgmList />
              </UserRoute>
            }
          />
          <Route
            path="info"
            element={
              <UserRoute>
                <InfoMng />
              </UserRoute>
            }
          />
          <Route
            path="subuser"
            element={
              <ManagerRoute>
                <SubUserMng />
              </ManagerRoute>
            }
          />
          <Route
            path="company"
            element={
              <ManagerRoute>
                <Company />
              </ManagerRoute>
            }
          />
          <Route
            path="pgmlist"
            element={
              <UserRoute>
                <PgmList />
              </UserRoute>
            }
          />
          <Route
            path="coupon"
            element={
              <ManagerRoute>
                <CouponMng />
              </ManagerRoute>
            }
          />
          <Route
            path="coupon2"
            element={
              <ManagerRoute>
                <CouponMng2 />
              </ManagerRoute>
            }
          />
          <Route
            path="geo"
            element={
              <UserRoute>
                <GeoCoding />
              </UserRoute>
            }
          />
          <Route
            path="active"
            element={
              <ManagerRoute>
                <ActiveCodeMng />
              </ManagerRoute>
            }
          />
          <Route
            path="stat"
            element={
              <AdminRoute>
                <LogStat />
              </AdminRoute>
            }
          />
          <Route
            path="log"
            element={
              <AdminRoute>
                <LogMng />
              </AdminRoute>
            }
          />
          <Route
            path="user"
            element={
              <AdminRoute>
                <UserMng />
              </AdminRoute>
            }
          />
          <Route
            path="pgm"
            element={
              <AdminRoute>
                <PgmMng />
              </AdminRoute>
            }
          />
          <Route
            path="adminapikey"
            element={
              <AdminRoute>
                <ApiKeyMng />
              </AdminRoute>
            }
          />
          <Route
            path="filter"
            element={
              <AdminRoute>
                <ExtensionMng />
              </AdminRoute>
            }
          />
          <Route
            path="admincoupon"
            element={
              <AdminRoute>
                <AdminCouponMng />
              </AdminRoute>
            }
          />
          <Route
            path="admincompany"
            element={
              <AdminRoute>
                <AdminCompanyMng />
              </AdminRoute>
            }
          />
          <Route
            path="adminactive"
            element={
              <AdminRoute>
                <AdminActiveCodeMng />
              </AdminRoute>
            }
          />
          <Route
            path="disable"
            element={
              <AdminRoute>
                <DisableMng />
              </AdminRoute>
            }
          />
          <Route
            path="mail"
            element={
              <AdminRoute>
                <MailMng />
              </AdminRoute>
            }
          />
          <Route
            path="mail/forward"
            element={
              <AdminRoute>
                <MailForward />
              </AdminRoute>
            }
          />
          <Route
            path="mail/detail"
            element={
              <AdminRoute>
                <MailDetail />
              </AdminRoute>
            }
          />
          <Route
            path="form"
            element={
              <AdminRoute>
                <FormMng />
              </AdminRoute>
            }
          />
          <Route
            path="notice"
            element={
              <UserRoute>
                <List
                  name="공지사항"
                  kind="Notice"
                  file
                  columns={[
                    { id: 'row_number', label: 'No', minWidth: 10, align: 'center' },
                    { id: 'subject', label: '제목', minWidth: 320, align: 'center', subjectAlign: 'left' },
                    { id: 'created_id', label: '등록자', minWidth: 20, align: 'center' },
                    { id: 'created_at', label: '등록일시', minWidth: 20, align: 'center' },
                    { id: 'hits', label: '조회', minWidth: 10, align: 'center' }
                  ]}
                />
              </UserRoute>
            }
          />
          <Route
            path="qna"
            element={
              <UserRoute>
                <List
                  name="QnA"
                  kind="QnA"
                  file
                  columns={[
                    { id: 'row_number', label: 'No', minWidth: 10, align: 'center' },
                    { id: 'subject', label: '제목', minWidth: 320, align: 'center', subjectAlign: 'left' },
                    { id: 'created_id', label: '등록자', minWidth: 20, align: 'center' },
                    { id: 'created_at', label: '등록일시', minWidth: 20, align: 'center' },
                    { id: 'hits', label: '조회', minWidth: 10, align: 'center' }
                  ]}
                />
              </UserRoute>
            }
          />
          <Route
            path="tips"
            element={
              <UserRoute>
                <List
                  name="Tips"
                  kind="Tips"
                  file
                  columns={[
                    { id: 'row_number', label: 'No', minWidth: 10, align: 'center' },
                    { id: 'subject', label: '제목', minWidth: 320, align: 'center', subjectAlign: 'left' },
                    { id: 'created_id', label: '등록자', minWidth: 20, align: 'center' },
                    { id: 'created_at', label: '등록일시', minWidth: 20, align: 'center' },
                    { id: 'hits', label: '조회', minWidth: 10, align: 'center' }
                  ]}
                />
              </UserRoute>
            }
          />
          <Route
            path="reference"
            element={
              <UserRoute>
                <List
                  name="자료실"
                  kind="Reference"
                  file
                  columns={[
                    { id: 'row_number', label: 'No', minWidth: 10, align: 'center' },
                    { id: 'subject', label: '제목', minWidth: 320, align: 'center', subjectAlign: 'left' },
                    { id: 'created_id', label: '등록자', minWidth: 20, align: 'center' },
                    { id: 'created_at', label: '등록일시', minWidth: 20, align: 'center' },
                    { id: 'hits', label: '조회', minWidth: 10, align: 'center' }
                  ]}
                />
              </UserRoute>
            }
          />
          <Route
            path="secret"
            element={
              <UserRoute>
                <List
                  name="1:1 문의"
                  kind="secret"
                  file
                  columns={[
                    { id: 'row_number', label: 'No', minWidth: 10, align: 'center' },
                    { id: 'status_nm', label: '상태', minWidth: 20, align: 'center', subjectAlign: 'center' },
                    { id: 'subject', label: '제목', minWidth: 320, align: 'center', subjectAlign: 'left' },
                    { id: 'created_id', label: '등록자', minWidth: 20, align: 'center' },
                    { id: 'created_at', label: '등록일시', minWidth: 20, align: 'center' },
                    { id: 'hits', label: '조회', minWidth: 10, align: 'center' }
                  ]}
                />
              </UserRoute>
            }
          />
          <Route
            path="register"
            element={
              <UserRoute>
                <Register state="register" />
              </UserRoute>
            }
          />
          <Route
            path="modify"
            element={
              <UserRoute>
                <Register state="modify" />
              </UserRoute>
            }
          />
          <Route
            path="detail"
            element={
              <UserRoute>
                <Detail />
              </UserRoute>
            }
          />
          <Route
            path="reply"
            element={
              <UserRoute>
                <Register state="reply" />
              </UserRoute>
            }
          />
          <Route path="dashboard">
            <Route
              path=""
              element={
                <AdminRoute>
                  <DACDashBoard />
                </AdminRoute>
              }
            />
            <Route
              path="order-hist"
              element={
                <AdminRoute>
                  <DACDashBoardOrdHist />
                </AdminRoute>
              }
            />
            <Route
              path="anls-sales"
              element={
                <AdminRoute>
                  <DACDashBoardAnlsSales />
                </AdminRoute>
              }
            />
            <Route
              path="anls-sw"
              element={
                <AdminRoute>
                  <DACDashBoardAnlsSw />
                </AdminRoute>
              }
            />
            <Route
              path="anls-user"
              element={
                <AdminRoute>
                  <DACDashBoardAnlsUser />
                </AdminRoute>
              }
            />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;

const RequireAuth = ({ children }) => {
  let location = useLocation();
  let authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.checkAuth();
  }, [location.pathname]);

  return <AuthRoute>{children}</AuthRoute>;
};

const AuthRoute = ({ children }) => {
  const location = useLocation();

  if (!authUtils.useIsLogin()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
